'use client';
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ProjectSubmissionForm from './components/ProjectSubmissionForm';
import { Toaster } from 'sonner';

export default function ProjectSubmissionPage() {
  return (
    <main className="min-h-screen bg-[#07111F]">
      <Toaster position="top-right" richColors />
      <Header />
      <ProjectSubmissionForm />
      <Footer />
    </main>
  );
}